import React from 'react';
import { FaFileImport, FaListUl, FaSyncAlt } from 'react-icons/fa';

import SecondarySidebar from '../../components/SideBar/SecondarySidebar';
import { ongletsDe } from '../../components/Navigation/navigation';
import useOnglet from '../../components/Navigation/useOnglet';
import PayrollImport from './PayrollImport';
import PayrollLines from './PayrollLines';
import PayrollSync from './PayrollSync';

const ICONES = { lignes: <FaListUl />, import: <FaFileImport />, sync: <FaSyncAlt /> };

// Les sections et leur ordre viennent de la carte de navigation
// (Yros/Kavero#416) ; la section ouverte vit dans l'adresse.
const SECTIONS = ongletsDe('/paie/rh').map((onglet) => ({ ...onglet, icon: ICONES[onglet.id] }));

const PayrollHub = () => {
    const [activeTab, setActiveTab] = useOnglet(SECTIONS);

    return (
        <div className="flex gap-6">
            <div className="w-72 flex-shrink-0 self-start sticky top-6">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                    <div className="px-6 py-4 border-b border-gray-200">
                        <h3 className="text-lg font-semibold text-gray-800">Paie</h3>
                        <p className="text-sm text-gray-600 mt-1">
                            Consulter et alimenter les éléments de paie
                        </p>
                    </div>
                    <div className="p-2">
                        <SecondarySidebar
                            menuItems={SECTIONS}
                            setActiveTab={setActiveTab}
                            activeTab={activeTab}
                        />
                    </div>
                </div>
            </div>

            <div className="flex-1 min-w-0">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                    {activeTab === 'import' ? (
                        <PayrollImport />
                    ) : activeTab === 'sync' ? (
                        <PayrollSync />
                    ) : (
                        <PayrollLines />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PayrollHub;
